module.exports = __webpack_public_path__ + "syndication/Components/PersistentActions/email.4da1cff3bca35bac4982e88ce00b88ee.svg";